import { ITrackingPage } from '@pdqdev/pdq-shared/dist/interfaces/shopPlugin/ITrackingPage';

export const TrackingPageDefaultValues = {
  settings: {
    internalName: null,
    accentColor: '#884DFF',
    colorScheme: 'semantic' as 'semantic' | 'grayscale',
    unsuccessfulTrackingStatusColor: '#E40C0C',
    url: null,
    searchPage: {
      title: 'Track your package',
      inputPlaceholder: 'Text inside the order/track input field',
      emailPlaceholder: 'Email address...',
      phonePlaceholder: 'Phone number...',
      buttonText: 'Search',
      titleAlignment: 'left',
      verifyByTrackingOrOrderNumber: true,
      verificationStrategy: 'none' as ITrackingPage.VerificationStrategy,
    },
  },
  widgets: {
    couponCodes: [],
    productSection: {
      showProductSection: true,
      title: 'Items in this shipment',
      bodyText: '',
    },
    details: {
      showTrackingDetails: true,
      showDetailedTrackingHistory: true,
      displayMessageForUntrackedShipments: false,
      carriersToDisplayMessageFor: ['all_untracked_carriers'],
      messageForUntrackedShipments: null,
      displayMessageWhenHandedOverToDifferentCarrier: false,
      messageWhenHandedOverToDifferentCarrier: null,
      displayTrackingNumber: false,
      showDeliveryStatus: false,
    },
    simpleTracker: {
      showTrackingProgress: true,
      unsuccessfulTrackingStatusColor: '#E40C0C',
      showFutureSteps: true,
    },
    deliveryPromise: {
      showShippingMethodPromise: true,
      showExpectedLateIndicator: false,
      showCarrierETA: false,
    },
  },
  trackingHistory: [
    {
      status: 'Processed through USPS facility',
      location: 'Carol Stream 60199, US',
      date: 'Jan 29, 01:30',
    },
    {
      status: 'Arrived at USPS facility',
      location: 'Carol Stream 60199, US',
      date: 'Jan 28, 09:20',
    },
    {
      status: 'Departed regional facility',
      location: 'Carol Stream 60199, US',
      date: 'Jan 28, 00:00',
    },
    {
      status: 'Picked up by USPS',
      location: 'Fifth avenue, US',
      date: 'Jan 27, 02:44',
    },
    {
      status: 'Received',
      location: 'Fifth avenue, US',
      date: 'Jan 26, 07:49',
    },
  ],

  lineItems: [
    {
      name: 'Eggs',
      price: '32',
      quantity: 12,
      image: null,
    },
  ],
};
